import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api/apiServises';
import {
  ADD_FINAL_INSPECTION_LIST,
  FETCH_FINAL_INSPECTION_BY_ID,
  FETCH_FINAL_INSPECTION_FORM,
  FETCH_FINAL_INSPECTION_LIST,
  FETCH_LAST_FRAME_QCI_DATA,
  FINAL_INSPECTION_COMPLETED_STAGE,
  FINAL_INSPECTION_DELETE,
  FINAL_INSPECTION_FLOW_HISTORY,
  //INSPECTION_REPORT_DATA,
  UPDATE_ALL_ONE_ACTION_LATEST,
  VIEW_FINAL_INSPECTION_FORM,
  FETCH_INSPECTED_SHELL_TYPES,
  FETCH_PRECEILING_REPORT_DATA,
  FETCH_FINAL_REPORT_DATA,
  //GET_SHELL_NUMBERS,
  //GET_COACH_NUMBERS,
  //GET_PLUGDOOR_PARAMS,
  DELETE_QFR_PRECELLING_DATA,
  DELETE_QFR_FINAL_QUALITY_DATA,

  
} from '../../../api/apiConstant';

export const fetchFinalInspectionForm = createAsyncThunk(
  'finalInspection/fetchFinalInspectionForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FINAL_INSPECTION_FORM, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchFinalInspectionList = createAsyncThunk(
  'finalInspection/fetchFinalInspectionList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_FINAL_INSPECTION_LIST, {params:{...formData}});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const AddFinalInspectionList = createAsyncThunk(
  'finalInspection/AddFinalInspectionList',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_FINAL_INSPECTION_LIST, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchFinalInspectionById = createAsyncThunk(
  'finalInspection/fetchById',
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_FINAL_INSPECTION_BY_ID,body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const viewFinalInspectionForm = createAsyncThunk(
  'finalInspection/viewFinalInspectionForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_FINAL_INSPECTION_FORM, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const finalInspectionAction = createAsyncThunk(
  'finalInspection/finalInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, {...formData});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);

export const fetchFinalInspectionFlowHistory = createAsyncThunk(
  'finalInspection/flowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(FINAL_INSPECTION_FLOW_HISTORY,{id});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteFinalInspection = createAsyncThunk(
  'finalInspection/deleteFinalInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FINAL_INSPECTION_DELETE,formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchFinalInspectionCompletedStages = createAsyncThunk(
  'finalInspection/fetchCompletedStages',
  async (params, { rejectWithValue }) => {
    try {
      const res = await api.get(FINAL_INSPECTION_COMPLETED_STAGE, { params });
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const fetchLastFrameQciData = createAsyncThunk(
  'finalInspection/fetchLastFrameQciData ',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FETCH_LAST_FRAME_QCI_DATA, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch materials');
    }
  },
);



export const fetchInspectedShellTypes = createAsyncThunk(
  'finalInspection/fetchInspectedShellTypes',  
  async (stage = 'preceiling', { rejectWithValue }) => {
    try {
      console.log(`🔍 Fetching inspected shell types for stage: ${stage}...`);
      
      // Use shorthand property (stage instead of stage: stage)
      const response = await api.post(FETCH_INSPECTED_SHELL_TYPES, {
        stage
      });
      
      console.log('✅ API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ API Error Details:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch inspected shell types'
      );
    }
  },
);

// In finalInspectionThunk.js
export const fetchPreceilingReportData = createAsyncThunk(
  'finalInspection/fetchPreceilingReportData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_PRECEILING_REPORT_DATA, {params:{...formData}});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch preceiling report data'
      );
    }
  },
);

export const deleteQfrPreceilingData = createAsyncThunk(
  'finalInspection/deleteQfrPreceilingData',
  async (id, { rejectWithValue }) => {
    console.log(`Attempting to delete QFR preceiling data with ID: ${id}...`);
    try {
      const response = await api.delete(`${DELETE_QFR_PRECELLING_DATA}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete QFR preceiling data'
      );
    }
  },
);

export const deleteQfrFinalQualityData = createAsyncThunk(
  'finalInspection/deleteQfrFinalQualityData',
  async (id, { rejectWithValue }) => {
    console.log(`Attempting to delete QFR final quality data with ID: ${id}...`);
    try {
      const response = await api.delete(`${DELETE_QFR_FINAL_QUALITY_DATA}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete QFR final quality data'
      );
    }
  },
);

// Final Quality

// For POST request with stage in body
export const fetchInspectedShellTypesForQuality = createAsyncThunk(
  'finalInspection/fetchInspectedShellTypesForQuality',
  async (stage = 'final', { rejectWithValue }) => {
    try {
      console.log(`🔍 Fetching inspected shell types for stage: ${stage}...`);
      
      // POST request with stage in body
      const response = await api.post('/fetch-inspected-shell-type', { stage });
      
      console.log('✅ API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ API Error Details:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch inspected shell types'
      );
    }
  },
);
//QFRFinalQualityList
export const fetchFinalReportData = createAsyncThunk(
  'finalInspection/fetchFinalReportData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_FINAL_REPORT_DATA, {params:{...formData}});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch final report data'
      );
    }
  },
);
// export const fetchInspectionReports = createAsyncThunk(
//   'finalInspection/fetchInspectionReports',
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await api.get(INSPECTION_REPORT_DATA, { params: formData || {} });
//       console.log('📊 Inspection Reports Response:', response.data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message || 'Failed to fetch inspection reports');
//     }
//   },
// );

// ✅ FIXED: fetchShellNumbers - Using the imported constant
// export const fetchShellNumbers = createAsyncThunk(
//   'finalInspection/fetchShellNumbers',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(GET_SHELL_NUMBERS);
//       console.log('📊 Shell Numbers Response:', response.data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.response?.data ||
//           error.message ||
//           'Failed to fetch shell numbers'
//       );
//     }
//   }
// );

// ✅ FIXED: fetchCoachNumbers - Using the imported constant
// export const fetchCoachNumbers = createAsyncThunk(
//   'finalInspection/fetchCoachNumbers',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get(GET_COACH_NUMBERS);
//       console.log('📊 Coach Numbers Response:', response.data);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.response?.data ||
//           error.message ||
//           'Failed to fetch coach numbers'
//       );
//     }
//   }
// );

// ✅ FIXED: fetchPlugDoorParams - Using the imported constant
// export const fetchPlugDoorParams = createAsyncThunk(
//   'finalInspection/fetchPlugDoorParams',
//   async (shellType, { rejectWithValue }) => {
//     try {
//       console.log(`🔍 Fetching plugdoor params for: ${shellType}`);
//       const response = await api.get(GET_PLUGDOOR_PARAMS, { params: { shell_type: shellType } });
//       console.log('📊 PlugDoor Params Response:', response.data);
//       return response.data;
//     } catch (error) {
//       console.error('❌ Error fetching plugdoor params:', error);
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.response?.data ||
//           error.message ||
//           'Failed to fetch plugdoor parameters'
//       );
//     }
//   }
// );